import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SubscriptionListPage } from './subscription-list';

@NgModule({
  declarations: [
    SubscriptionListPage,
  ],
  imports: [
    IonicPageModule.forChild(SubscriptionListPage),
  ],
  exports: [
    SubscriptionListPage
  ]
})
export class SubscriptionListPageModule { }



// WEBPACK FOOTER //
// ./src/pages/subscription-list/subscription-list.module.ts